/* KAI · Poslovna darila - tema JS (brez odvisnosti, brez košarice: vse gre kot povpraševanje) */
(function () {
  'use strict';

  var qs = function (root, s) { return root.querySelector(s); };
  var qsa = function (root, s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var MAX_FILE = 20 * 1024 * 1024;

  /* ---------- Glava ---------- */
  var header = document.querySelector('[data-kai-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    var toggle = header.querySelector('[data-kai-menu-toggle]');
    var nav = document.getElementById('KaiMobileNav');
    if (toggle && nav) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!open));
        if (open) nav.removeAttribute('open'); else nav.setAttribute('open', '');
      });
      nav.addEventListener('click', function (e) {
        if (e.target.closest('a')) { toggle.setAttribute('aria-expanded', 'false'); nav.removeAttribute('open'); }
      });
    }
  }

  /* ---------- Postopen prikaz ---------- */
  var reveals = document.querySelectorAll('.kai-reveal');
  if ('IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode)) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* Po uspešni oddaji pomakni na potrditev */
  var sent = document.querySelector('[data-kai-sent]');
  if (sent) setTimeout(function () { sent.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 200);

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- Logotip: samo predogled v brskalniku ---------- */
  function initLogo(root, onChange) {
    var input = qs(root, '[data-kai-file]');
    if (!input) return { has: function () { return false; }, name: function () { return ''; }, reset: function () {} };
    var nameEl = qs(root, '[data-kai-file-name]');
    var metaEl = qs(root, '[data-kai-file-meta]');
    var iconEl = qs(root, '[data-kai-file-icon]');
    var errEl = qs(root, '[data-kai-file-error]');
    var logoImg = qs(root, '[data-kai-logo]');
    var logoPh = qs(root, '[data-kai-logo-ph]');
    var scaleWrap = qs(root, '[data-kai-scale-wrap]');
    var scale = qs(root, '[data-kai-scale]');
    var drop = input.closest('.kai-dropzone');
    var defName = nameEl.textContent, defMeta = metaEl ? metaEl.textContent : '', defIcon = iconEl.innerHTML;
    var phText = logoPh ? logoPh.textContent : '';
    // isti logotip se pokaže tudi na drugih straneh (npr. stranica škatle)
    function mirror(src) {
      qsa(root, '[data-kai-logo-mirror]').forEach(function (m) { if (src) { m.src = src; m.hidden = false; } else { m.hidden = true; m.removeAttribute('src'); } });
      qsa(root, '[data-kai-logo-mirror-ph]').forEach(function (m) { m.hidden = !!src; });
    }
    var fileName = '';

    function reset() {
      input.value = ''; fileName = '';
      nameEl.textContent = defName; if (metaEl) metaEl.textContent = defMeta; iconEl.innerHTML = defIcon;
      if (logoImg) { logoImg.hidden = true; logoImg.removeAttribute('src'); }
      if (logoPh) { logoPh.hidden = false; logoPh.textContent = phText; }
      mirror(null);
      if (scaleWrap) scaleWrap.hidden = true;
      if (onChange) onChange();
    }
    input.addEventListener('change', function () {
      if (errEl) errEl.textContent = '';
      var f = input.files && input.files[0];
      if (!f) { reset(); return; }
      if (f.size > MAX_FILE) { reset(); if (errEl) errEl.textContent = 'Datoteka je prevelika (največ 20 MB).'; return; }
      fileName = f.name;
      nameEl.textContent = f.name;
      if (metaEl) metaEl.textContent = 'Za predogled · datoteko nam pošljete po e-pošti';
      if (/^image\//.test(f.type)) {
        var r = new FileReader();
        r.onload = function (e) {
          if (logoImg) { logoImg.src = e.target.result; logoImg.hidden = false; }
          if (logoPh) logoPh.hidden = true;
          mirror(e.target.result);
          iconEl.innerHTML = '<img alt="" src="' + e.target.result + '">';
          if (scaleWrap) scaleWrap.hidden = false;
          if (onChange) onChange();
        };
        r.readAsDataURL(f);
      } else {
        if (logoImg) logoImg.hidden = true;
        if (logoPh) { logoPh.hidden = false; logoPh.textContent = 'Logo (' + (f.name.split('.').pop() || '').toUpperCase() + ')'; }
        if (onChange) onChange();
      }
    });
    if (drop) {
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function () { drop.classList.add('is-drag'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function () { drop.classList.remove('is-drag'); }); });
    }
    if (scale && logoImg) scale.addEventListener('input', function () { logoImg.style.setProperty('--scale', scale.value / 100); });
    return { has: function () { return !!fileName; }, name: function () { return fileName; }, reset: reset };
  }

  function firstInvalid(form) {
    return qsa(form, '[required]').find(function (el) { return !el.value.trim() || (el.type === 'email' && !/^\S+@\S+\.\S+$/.test(el.value)); });
  }

  /* ---------- Konfigurator (škatla, gel, bon) ---------- */
  function initConfigurator(root) {
    var form = root.querySelector('form');
    var $ = function (s) { return qs(root, s); };
    var $$ = function (s) { return qsa(root, s); };
    var minQty = parseInt(root.getAttribute('data-min'), 10) || 1;
    var summary = $('[data-kai-summary]');
    var logoProp = $('[data-kai-logo-prop]');
    var brand = $('[data-kai-brand]');
    var toggle = $('[data-kai-logo-toggle]');
    var upload = $('[data-kai-upload]');
    var qtyInput = $('[data-kai-qty-input]');
    var msgProp = $('[data-kai-msg-prop]');
    var sideInput = $('[data-kai-side-input]');

    var logo = initLogo(root, function () { updateLogoProp(); renderSummary(); if (logo && logo.has()) showFace('front'); });
    function updateLogoProp() {
      if (!logoProp) return;
      if (toggle && !toggle.checked) { logoProp.value = 'Ne – brez etikete'; return; }
      logoProp.value = logo.has() ? 'Da – ' + logo.name() + ' (pošljem po e-pošti)' : 'Da – pošljem po e-pošti';
    }

    /* Strani škatle */
    var faces = $$('[data-kai-face]');
    var faceBtns = $$('[data-kai-face-btn]');
    function showFace(name) {
      if (!faces.some(function (f) { return f.getAttribute('data-kai-face') === name; })) return;
      faces.forEach(function (f) { f.classList.toggle('is-active', f.getAttribute('data-kai-face') === name); });
      faceBtns.forEach(function (b) { b.setAttribute('aria-selected', String(b.getAttribute('data-kai-face-btn') === name)); });
    }
    faceBtns.forEach(function (b) { b.addEventListener('click', function () { showFace(b.getAttribute('data-kai-face-btn')); }); });
    $$('[data-kai-goto-face]').forEach(function (step) {
      var go = function () { showFace(step.getAttribute('data-kai-goto-face')); };
      step.addEventListener('focusin', go); step.addEventListener('change', go);
    });

    /* Izbire (okus, velikost, vrednost) → predogled */
    var jar = $('[data-kai-jar]');
    function applyRoles() {
      $$('[data-kai-role]').forEach(function (fs) {
        var c = fs.querySelector('input:checked'); if (!c) return;
        var role = fs.getAttribute('data-kai-role');
        if (role === 'flavor' && jar && c.getAttribute('data-color')) jar.style.setProperty('--c', c.getAttribute('data-color'));
        if (role === 'size' && jar) {
          var total = fs.querySelectorAll('input').length, i = parseInt(c.getAttribute('data-index'), 10) || 1;
          jar.style.setProperty('--h', (40 + (i - 1) * (28 / Math.max(1, total - 1))) + '%');
        }
        $$('[data-kai-role-text="' + role + '"]').forEach(function (el) {
          el.textContent = /poljub/i.test(c.value) ? 'po želji' : c.value;
        });
      });
    }
    $$('[data-kai-role]').forEach(function (fs) { fs.addEventListener('change', function () { applyRoles(); renderSummary(); }); });

    /* Oblika bona */
    var formatPreview = $('[data-kai-format-preview]');
    $$('[data-kai-format]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked && formatPreview) formatPreview.textContent = r.value.split(' (')[0]; renderSummary(); });
    });

    /* Stikalo etikete */
    if (toggle) toggle.addEventListener('change', function () {
      upload.hidden = !toggle.checked; if (brand) brand.hidden = !toggle.checked;
      if (!toggle.checked) logo.reset();
      updateLogoProp(); renderSummary();
    });

    /* Sporočilo */
    var msgOpts = $$('[data-kai-msg-option]');
    var msgCustom = $('[data-kai-msg-custom]');
    var msgText = $('[data-kai-msg-text]');
    var msgCount = $('[data-kai-msg-count]');
    var msgPreview = $('[data-kai-msg-preview]');
    function updateMessage() {
      if (!msgProp) return;
      var sel = msgOpts.find(function (o) { return o.checked; });
      var val = sel ? sel.value : '';
      var isCustom = val === '__custom';
      if (msgCustom) msgCustom.hidden = !isCustom;
      if (isCustom) val = (msgText.value || '').trim();
      if (msgCount && msgText) msgCount.textContent = msgText.value.length;
      msgProp.value = val || 'Brez';
      if (msgPreview) { msgPreview.textContent = val; msgPreview.hidden = !val; }
    }
    msgOpts.forEach(function (o) { o.addEventListener('change', function () { updateMessage(); renderSummary(); if (o.value === '__custom' && msgText) msgText.focus(); }); });
    if (msgText) msgText.addEventListener('input', function () { updateMessage(); renderSummary(); });

    /* Stranica */
    var sideText = $('[data-kai-side-text]');
    var sideCount = $('[data-kai-side-count]');
    var sideFile = $('[data-kai-side-file]');
    var sideImg = $('[data-kai-side-img]');
    var sideName = $('[data-kai-side-name]');
    var sideIcon = $('[data-kai-side-icon]');
    var sideProp = $('[data-kai-side-prop]');
    var sideIconHTML = sideIcon ? sideIcon.innerHTML : '';
    function updateSide() {
      if (!sideText) return;
      var t = sideInput ? sideInput.value.trim() : '';
      var hasImg = sideImg && !sideImg.hidden;
      sideText.textContent = t || (hasImg ? '' : sideText.getAttribute('data-placeholder'));
      sideText.classList.toggle('is-placeholder', !t && !hasImg);
      sideText.hidden = !t && hasImg;
      sideText.parentNode.classList.toggle('has-content', !!t || hasImg);
      if (sideCount && sideInput) sideCount.textContent = sideInput.value.length;
    }
    if (sideInput) sideInput.addEventListener('input', function () { updateSide(); renderSummary(); });
    if (sideFile) sideFile.addEventListener('change', function () {
      var f = sideFile.files && sideFile.files[0];
      if (!f || f.size > MAX_FILE) {
        sideFile.value = ''; sideImg.hidden = true; sideIcon.innerHTML = sideIconHTML;
        sideName.textContent = f ? 'Datoteka je prevelika (največ 20 MB)' : 'Dodajte sliko na stranico škatle';
        sideProp.value = 'Ne'; updateSide(); renderSummary(); return;
      }
      sideName.textContent = f.name; sideProp.value = 'Da – ' + f.name + ' (pošljem po e-pošti)';
      if (/^image\//.test(f.type)) {
        var r = new FileReader();
        r.onload = function (e) { sideImg.src = e.target.result; sideImg.hidden = false; sideIcon.innerHTML = '<img alt="" src="' + e.target.result + '">'; updateSide(); showFace('side'); };
        r.readAsDataURL(f);
      } else { sideImg.hidden = true; updateSide(); }
      renderSummary();
    });

    /* Količina */
    function clampQty(n) { n = parseInt(n, 10); return isNaN(n) || n < minQty ? minQty : n; }
    $$('[data-kai-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = parseInt(qtyInput.value, 10) || minQty;
        qtyInput.value = clampQty(b.getAttribute('data-kai-qty') === '+' ? q + 1 : q - 1); renderSummary();
      });
    });
    qtyInput.addEventListener('change', function () { qtyInput.value = clampQty(qtyInput.value); renderSummary(); });
    qtyInput.addEventListener('input', renderSummary);

    /* Povzetek */
    function renderSummary() {
      if (!summary) return;
      var rows = [];
      $$('[data-kai-role]').forEach(function (fs) {
        var c = fs.querySelector('input:checked'); var lg = fs.querySelector('legend');
        if (c) rows.push([lg ? lg.textContent : '', c.value]);
      });
      var fmt = $$('[data-kai-format]').find(function (r) { return r.checked; });
      if (fmt) rows.push(['Oblika', fmt.value]);
      if (logoProp) rows.push(['Logotip', toggle && !toggle.checked ? 'brez' : (logo.has() ? logo.name() : 'pošljem po e-pošti')]);
      if (msgProp) rows.push(['Napis', msgProp.value]);
      if (sideInput && sideInput.value.trim()) {
        var t = sideInput.value.trim();
        rows.push(['Posvetilo', t.length > 40 ? t.slice(0, 40) + ' …' : t]);
      }
      rows.push(['Količina', clampQty(qtyInput.value) + ' kos']);
      summary.innerHTML = rows.map(function (r) { return '<li><span>' + esc(r[0]) + '</span><span>' + esc(r[1]) + '</span></li>'; }).join('');
    }

    applyRoles(); updateMessage(); updateSide(); updateLogoProp(); renderSummary();

    form.addEventListener('submit', function (e) {
      qtyInput.value = clampQty(qtyInput.value);
      updateLogoProp(); updateMessage();
      if (msgText && msgOpts.some(function (o) { return o.checked && o.value === '__custom'; }) && !msgText.value.trim()) {
        e.preventDefault(); msgText.focus(); return;
      }
      var bad = firstInvalid(form);
      if (bad) { e.preventDefault(); bad.focus(); if (bad.reportValidity) bad.reportValidity(); return; }
      var btn = $('[data-kai-submit]'); if (btn) { btn.disabled = true; btn.textContent = 'Pošiljam …'; }
    });
  }

  /* ---------- Sestavi svoje darilo ---------- */
  function initBuilder(form) {
    var $ = function (s) { return qs(form, s); };
    var $$ = function (s) { return qsa(form, s); };
    var grid = $('.kai-builder__grid');
    var maxItems = parseInt(grid && grid.getAttribute('data-max-items'), 10) || 99;
    var items = $$('[data-kai-bitem]');
    var list = $('[data-kai-blist]');
    var emptyHTML = list.innerHTML;
    var setsInput = $('[data-kai-bsets]');
    var minSets = parseInt(setsInput.getAttribute('min'), 10) || 1;
    var err = $('[data-kai-berror]');
    var content = $('[data-kai-bcontent]');
    var logoProp = $('[data-kai-logo-prop]');
    var logo = initLogo(form, function () { logoProp.value = logo.has() ? 'Da – ' + logo.name() + ' (pošljem po e-pošti)' : 'Ne'; });

    function selected() {
      return items.map(function (card) {
        var q = parseInt(card.querySelector('[data-kai-bqty]').value, 10) || 0;
        var sel = card.querySelector('[data-kai-bvariant]');
        return { qty: q, title: card.getAttribute('data-title') + (sel ? ' – ' + sel.value : '') };
      }).filter(function (x) { return x.qty > 0; });
    }
    function count() { return selected().reduce(function (a, x) { return a + x.qty; }, 0); }
    function render() {
      var sel = selected();
      list.innerHTML = sel.length ? sel.map(function (x) {
        return '<li><span>' + esc(x.title) + '</span><span>' + x.qty + '×</span></li>';
      }).join('') : emptyHTML;
      content.value = sel.map(function (x) { return x.qty + '× ' + x.title; }).join(', ');
      items.forEach(function (card) {
        card.classList.toggle('is-selected', (parseInt(card.querySelector('[data-kai-bqty]').value, 10) || 0) > 0);
      });
    }
    items.forEach(function (card) {
      var input = card.querySelector('[data-kai-bqty]');
      card.querySelectorAll('[data-kai-bstep]').forEach(function (b) {
        b.addEventListener('click', function () {
          var q = parseInt(input.value, 10) || 0;
          if (b.getAttribute('data-kai-bstep') === '+') {
            if (count() >= maxItems) { err.textContent = 'V eno darilo lahko dodate največ ' + maxItems + ' izdelkov.'; return; }
            q++;
          } else { q = Math.max(0, q - 1); }
          err.textContent = ''; input.value = q; render();
        });
      });
      input.addEventListener('change', function () { input.value = Math.max(0, parseInt(input.value, 10) || 0); render(); });
      var sel = card.querySelector('[data-kai-bvariant]');
      if (sel) sel.addEventListener('change', render);
    });
    function sets() { var n = parseInt(setsInput.value, 10); return isNaN(n) || n < minSets ? minSets : n; }
    $$('[data-kai-bsets-step]').forEach(function (b) {
      b.addEventListener('click', function () { setsInput.value = Math.max(minSets, sets() + (b.getAttribute('data-kai-bsets-step') === '+' ? 1 : -1)); });
    });
    setsInput.addEventListener('change', function () { setsInput.value = sets(); });

    form.addEventListener('submit', function (e) {
      render(); setsInput.value = sets();
      if (!selected().length) { e.preventDefault(); err.textContent = 'Najprej dodajte vsaj en izdelek v darilo.'; if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      var bad = firstInvalid(form);
      if (bad) { e.preventDefault(); bad.focus(); if (bad.reportValidity) bad.reportValidity(); return; }
      var btn = $('[data-kai-badd]'); btn.disabled = true; btn.textContent = 'Pošiljam …';
    });
    render();
  }

  function boot(scope) {
    qsa(scope, '[data-kai-config]').forEach(initConfigurator);
    qsa(scope, '#KaiBuilderForm').forEach(initBuilder);
  }
  boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
